<div class="detail-card" [nbSpinner]="this.isLoading">
  <div class="card-bar">
    <h3>Mass Balance</h3>
    <span class="count-pill">{{this.massBalance.length}}</span>
  </div>

  <div class="card-empty" *ngIf="!this.isLoading && !this.massBalance.length">No mass balance entries for this lot.</div>

  <ng-container *ngIf="this.massBalance.length">
    <div class="card-grid">
      <ejs-grid [dataSource]="this.massBalance" [columns]="this.columns" [aggregates]="this.aggregates"
        [allowPaging]="true" [pageSettings]="this.pageSettings" [allowFiltering]="true"
        [filterSettings]="this.filterSettings" [allowSorting]="true" [allowTextWrap]="true" [enableHover]="true">
      </ejs-grid>
    </div>

    <div class="kw-mobile-list">
      <div class="card-row" *ngFor="let entry of this.massBalance | slice:0:mobileVisibleCount; trackBy: trackByEntry">
        <div class="card-row-top">
          <button type="button" class="reason-btn card-row-name" (click)="editReason(entry)">
            {{entry.reason}}<fa-icon [icon]="faPen" class="reason-icon"></fa-icon>
          </button>
          <span class="balance" [class.negative]="entry.balance < 0">{{entry.balance | number:'1.2-2'}}</span>
        </div>
        <span class="card-row-sub">
          {{entry.date | date}}<ng-container *ngIf="entry.itemName"> · {{entry.itemName}}</ng-container><ng-container *ngIf="entry.packoutCode"> · {{entry.packoutCode}}</ng-container>
        </span>
      </div>

      <button class="m-show-more" *ngIf="this.massBalance.length > mobileVisibleCount"
              mat-stroked-button (click)="showMoreMobile()">
        Show more ({{this.massBalance.length - mobileVisibleCount}} remaining)
      </button>
    </div>
  </ng-container>
</div>

<ng-template #dateTemplate let-data>{{data.date | date}}</ng-template>

<ng-template #reasonTemplate let-data>
  <button type="button" class="reason-btn" (click)="editReason(data)">
    {{data.reason}}<fa-icon [icon]="faPen" class="reason-icon"></fa-icon>
  </button>
</ng-template>
